<template>
    <div class="container mt-0 mb-3">
        <div class="row align-items-center mb-2">
            <h3 class="mt-4 mb-0">The tool will help you to...</h3>
            <div class="col-md-4">
                <img :src="optionsImgPath" alt="Userstanding your options" class="advice-img">
            </div>
            <div class="col-md-8">
                <h4>Understand your {{ schemeName }} options at retirement</h4>
                <p v-html="html('userhome.dboptions.understand-your-options.summary')"></p>
            </div>
        </div>

        <div class="row align-items-center mb-2">
            <div class="col-md-4">
                <img :src="jigsawImgPath" alt="Building a plan" class="advice-img">
            </div>
            <div class="col-md-8">
                <h4>Build your overall retirement plan</h4>
                <p v-html="templateHtml('userhome.dboptions.build-your-plan.summary', { schemeName })"></p>
            </div>
        </div>

        <div class="row align-items-center">
            <h3>Purpose of the tool</h3>
            <div class="col-md-4">
                <img :src="helpImgPath" alt="Finding help and advice" class="advice-img">
            </div>
            <div class="col-md-8">
                <h4>What the tool does</h4>
                <p v-for="p, i in htmlArray('userhome.dboptions.what-the-tool-does.summary')" :key="i" v-html="p"></p>

                <!-- Removed as GM has no further support options -->
                <!-- <strong> If you're making a retirement decision and would like support, the site can direct you to advisers 
                selected by the scheme, as well as other helpful resources.</strong> -->
                <!-- <p>
                     The information and calculations provided by the tool are for general information only and do not
                     constitute financial or other advice.
                </p> -->
                <!-- If you need any help or support, please click the "Get support" button in the top right-hand side of the page. -->
            </div>
        </div>

        <hr class="mt-4 mb-5">
    </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue';
import FinalSalaryScheme from '@/guiide/ts/assets/finalsalary/finalSalaryScheme';
import { useStore } from 'vuex';
import { useUIContent } from '@/guiide/ts/configuration/useUIContent';

const store = useStore();
const { html, htmlArray, templateHtml } = useUIContent();

const schemeName = ref("");
const optionsImgPath = computed<string>(() => {
    return getImagePath("userhome_options.png");
});

const jigsawImgPath = computed<string>(() => {
    return getImagePath("userhome_jigsaw.png");
});

const helpImgPath = computed<string>(() => {
    return getImagePath("userhome_help.png");
});

watch(
    () => store.state.retiree,
    async () => {
        if (!store.state.retiree) {
            return;
        }

        const schemeInfo: FinalSalaryScheme = store.state.retiree.finalSalaries.schemes[0];
        schemeName.value = schemeInfo.name;
    }
);

function getImagePath(imageName: string): string {
    if (!store.state.configuration) {
        return "";
    }

    const hintPath = store.state.configuration.imageHintPath;
    return hintPath.length == 0
        ? `/content/images/aon/${imageName}`
        : `/content/images/${hintPath}/${imageName}`;
}

</script>

<style scoped>
.advice-img {
  max-width: 70%;
  height: auto;
}
</style>